module.exports = __webpack_public_path__ + "static/homepage_sectiontwo-a409eef07dd2dfb8020966d3ead8c70e.svg";